import type { ActionReducerMap } from '@ngrx/store'
import { layoutReducer, type LayoutState } from './layout/layout-reducers'
import {
  authReducer,
  type AuthState,
} from './authentication/authentication.reducer'

export interface RootReducerState {
  authentication: AuthState
  layout: LayoutState
}

export const rootReducer: ActionReducerMap<RootReducerState> = {
  authentication: authReducer,
  layout: layoutReducer,
}
